/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Placeholder, PlaceholderText } from 'sarsaparilla';

export default function SummaryPlaceholder() {
    return (
        <div className="ia-summary-placeholder">
            <div className="ia-summary-placeholder-header">
                <Placeholder className="ia-summary-placeholder-image" />
            </div>
            <div className="ia-summary-placeholder-body">
                <div className="ia-summary-placeholder-message">
                    <PlaceholderText fontSize={14} lineHeight={14 * 1.2} lines={1} />
                </div>
            </div>
            <div className="ia-summary-placeholder-footer">
                <div className="ia-summary-placeholder-controls">
                    <Placeholder className="ia-summary-placeholder-cta" />
                </div>
            </div>
        </div>
    );
}
